import { ApplicationRef } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { createApplication } from '@angular/platform-browser';
import {
    ArticleCardComponent,
    ArticleCategoryTabsBlockComponent,
    ArticlesBlockComponent,
    ArticlesCarouselBlock,
    AuthorBlockComponent,
    BreadcrumbsComponent,
    ClickDimensionsBlockComponent,
    ContactUsBlockComponent,
    ContentBlockComponent,
    ContributorsSelectionBlockComponent,
    ExecutiveTeamMembersBlockComponent,
    ExpansionListBlockComponent,
    FooterComponent,
    FormBlockComponent,
    HeroBlockComponent,
    KeyTopicOneBlockComponent,
    KeyTopicTwoBlockComponent,
    KnowledgeCentreBlockComponent,
    KnowledgeCentreSelectionBlockComponent,
    MediaArticlesCarouselBlockComponent,
    MediaEnquiriesBlockComponent,
    NavigationBarComponent,
    NotificationCardComponent,
    PageHeaderBlockComponent,
    PressBlockComponent,
    SideMenuComponent,
    TurtlBlockComponent,
    VideoBlockComponent,
    YoutubeBlockComponent,
    HighlightBlockComponent,
    PromoBlockComponent,
    SpotlightBlockComponent
} from '@netwealth/nw-components';
import { appConfig } from './main.config';
import * as packageJson from './package.json';

(async () => {
    const app: ApplicationRef = await createApplication(appConfig);

    const elements: any[] = [
        [ArticleCardComponent, 'nw-article-card-block'],
        [ArticleCategoryTabsBlockComponent, 'nw-article-category-tabs-block'],
        [ArticlesBlockComponent, 'nw-articles-block-comp'],
        [ArticlesCarouselBlock, 'nw-articles-carousel-block'],
        [AuthorBlockComponent, 'nw-post-author-block'],
        [BreadcrumbsComponent, 'nw-breadcrumbs'],
        [ClickDimensionsBlockComponent, 'nw-click-dimensions-block'],
        [ContactUsBlockComponent, 'nw-contact-us-block'],
        [ContentBlockComponent, 'nw-key-content-block'],
        [ContributorsSelectionBlockComponent, 'nw-contributors-selection-block'],
        [ExecutiveTeamMembersBlockComponent, 'nw-executive-team-members-block'],
        [ExpansionListBlockComponent, 'nw-expansion-list-block'],
        [FooterComponent, 'nw-footer'],
        [HeroBlockComponent, 'nw-hero-block'],
        [KeyTopicOneBlockComponent, 'nw-key-topic-one-block'],
        [KeyTopicTwoBlockComponent, 'nw-key-topic-two-block'],
        [KnowledgeCentreBlockComponent, 'nw-knowledge-centre-block'],
        [KnowledgeCentreSelectionBlockComponent, 'nw-knowledge-centre-selection-block'],
        [MediaEnquiriesBlockComponent, 'nw-media-enquiries-block'],
        [NavigationBarComponent, 'nw-navigation-bar'],
        [NotificationCardComponent, 'nw-notification-card'],
        [PageHeaderBlockComponent, 'nw-page-header-block'],
        [PressBlockComponent, 'nw-press-block'],
        [SideMenuComponent, 'nw-side-menu'],
        [TurtlBlockComponent, 'nw-turtl-block'],
        [YoutubeBlockComponent, 'nw-youtube-block'],
        [VideoBlockComponent, 'nw-video-block'],
        [FormBlockComponent, 'nw-form-block'],
        [MediaArticlesCarouselBlockComponent, 'nw-media-articles-carousel-block'],
        [PromoBlockComponent, 'nw-promo-block'],
        [SpotlightBlockComponent, 'nw-spotlight-block'],
        [HighlightBlockComponent, 'nw-highlight-block']
    ];

    // Define Web Components
    for (const [component, name] of elements) {
        customElements.define(
            name,
            createCustomElement(component, { injector: app.injector })
        );
    }

    console.log(`Loaded: ${packageJson.name}; Version: ${packageJson.version}`);
})();
